import { TableCols } from "../interfaces/static-data";

export interface DataDictionary {
    id: number;
    term: string;
    inspireJsonJmespath: string;
    uiJsonJmespath: string;
    multiissuanceUiLabel: string;
    createdAt: string;
    updatedAt: string;
}

export const DATA_DICTIONARY_COLS: TableCols[] = [
    {
        key: 'term',
        displayValue: 'Term'
    },
    {
        key: 'inspireJsonJmespath',
        displayValue: 'inspire Jmespath'
    },
    {
        key: 'uiJsonJmespath',
        displayValue: 'UI Jmespath'
    },
    {
        key: 'multiissuanceUiLabel',
        displayValue: 'UI Label'
    },
    {
      key: 'lastUpdatedBy',
      displayValue: 'Last Updated By',
      hideOnForm: true
    },
    {
      key: 'updatedOn',
      displayValue: 'Updated On',
      hideOnForm: true
    }
];
